import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class RmAdminService {
  private apiUrl = `${environment.apiUrl}/admin/rm`;

  constructor(private http: HttpClient) {}

  private headers(): HttpHeaders {
    const token = localStorage.getItem('weddingly_admin_token') || localStorage.getItem('x-admin-token') || '';
    return new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` });
  }

  listRms(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}`, { headers: this.headers() });
  }

  createRm(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}`, data, { headers: this.headers() });
  }

  updateRm(rmId: string, data: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${rmId}`, data, { headers: this.headers() });
  }

  resetPassword(rmId: string, new_password: string): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${rmId}/reset-password`, { new_password }, { headers: this.headers() });
  }

  getRmClients(rmId: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${rmId}/clients`, { headers: this.headers() });
  }

  assignRm(clientProfileId: string, newRmId: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/assign`, { client_profile_id: clientProfileId, new_rm_id: newRmId }, { headers: this.headers() });
  }

  getExpressSubscribers(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/subscribers/express`, { headers: this.headers() });
  }
}
